import { render, staticRenderFns } from "./InvitacionCard.vue?vue&type=template&id=31efec48"
import script from "./InvitacionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports